import { useTranslation } from 'react-i18next';
import { useDeleteBettieProfilePicture } from '@pocapan/shared/domains/bettie/ui/hooks/useDeleteBettieProfilePicture';
import { useToggleBettieProfileVisibility } from '@pocapan/shared/domains/bettie/ui/hooks/useToggleBettieProfileVisibility';
import { useSuccessPhotoCardToast } from '../../template/edit-collected-photo-cards/hooks/useSuccessPhotoCardToast';

interface UseBettieProfilePictureActionsProps {
  chatRoomId: string;
}

export const useBettieProfilePictureActions = ({
  chatRoomId
}: UseBettieProfilePictureActionsProps) => {
  const { t } = useTranslation();
  const { mutateAsync: toggleBettieProfilePictureVisibility } = useToggleBettieProfileVisibility();
  const { mutateAsync: deleteProfilePicture } = useDeleteBettieProfilePicture();
  const successPhotoCardToast = useSuccessPhotoCardToast();

  const handleDeleteProfilePicture = async () => {
    if (!chatRoomId) return;

    try {
      const response = await deleteProfilePicture({ chatRoomId });
      if (response.bettiePictures) {
        successPhotoCardToast('bottom', t('BettieChangeProfile.profileDeleted') as string);
      } else {
        throw new Error('Failed to delete profile picture');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleToggleBettieProfileVisibility = async (visibility: boolean) => {
    if (!chatRoomId) return;
    try {
      const requestBody = {
        picture: {
          visibility: visibility
        }
      };
      const response = await toggleBettieProfilePictureVisibility({
        chatRoomId,
        body: requestBody
      });
      if (!response.bettiePictures) {
        throw new Error('Failed to toggle profile picture visibility');
      }
    } catch (error) {
      console.error(error);
    }
  };

  return {
    handleDeleteProfilePicture,
    handleToggleBettieProfileVisibility
  };
};
